module.exports = __webpack_public_path__ + "static/media/redTables.svg";